'use client'

import SidePanel from '../elements/SidePanel'
import ProfileCard from './ProfileCard'

export default function ProfileDrawer({ open, onClose, vendor, customer, isLoading }: { open: boolean, onClose: () => void, vendor: any, customer: any, isLoading: boolean, setIsLoading: (loading: boolean) => void }) {
  return (
    <SidePanel open={open} onClose={onClose} title="Миний бүртгэл">
      <ProfileCard customer={customer} isLoading={isLoading} vendor={vendor} onLinkClick={onClose} />
    </SidePanel>
  )
}
